<ng-container *ngIf="phaseId != null">
    <div class="barra">
        <options class="show-label" [optionstrip]="options" (clickOption)="clickOption($event)"></options>
        <shared-route-ecmr-actions *ngIf="showActions" [phaseId]="phaseId"></shared-route-ecmr-actions>
    </div>
  
    <shared-route-part-cmr-maintenance class="no-actions-rpc" [routePartCMR]="selectedRoutePartCMR" [readonly]="readonly"
        (routePartCMRUpdated)="onRoutePartCMRUpdated($event)" (refreshRoutePartCMR)="onRefreshRoutePartCMR($event)"
        (refreshRoute)="loadRouteData()">
    </shared-route-part-cmr-maintenance>
    
</ng-container>